<template>
  <section>
    <v-card flat tile v-if="study_group">
      <v-sheet class="overflow-y-auto unselectable" max-height="450px">
        <v-card-text  v-html="study_group.booking_policy"></v-card-text>
      </v-sheet>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
}
</script>